/**
 * Mamash Organics — Footer JS
 * Handles the WhatsApp subscribe form.
 */

(function () {
  'use strict';

  const form = document.getElementById('mamash-whatsapp-form');
  if (!form) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const input = document.getElementById('mamash-whatsapp-input');
    const phone = (input?.value || '').trim();
    if (!phone) return;

    const message = encodeURIComponent(
      "Hi Mamash Organics! I'd like to subscribe to the Mamash Ritual for skincare tips and exclusive offers."
    );
    window.open(`https://wa.me/919632073903?text=${message}`, '_blank', 'noopener,noreferrer');
    form.reset();
  });
})();
